import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const registerImporter = api((fields, name, mapping) =>
    mutate(
        gql`
            mutation RegisterImporter($fields: [String]!, $name: String!, $mapping: JSONObject) {
                registerImporter(fields: $fields, name: $name, mapping: $mapping)
            }
        `,
        { fields, name, mapping },
        { returns: "registerImporter" }
    )
)
